export const environment = {
  production: true,
  AG_GRID_LICENSE: 'LiquidX__Trading_Platform_9Devs10_June_2020__MTU5MTc0MzYwMDAwMA==50f70328a26daff8def3957cdafd16f3'
};
